import { Navigate } from 'react-router-dom';

const ProtectedRoute = ({ children }) => {
  const isLoggedIn = localStorage.getItem('isLoggedIn');

  return isLoggedIn === 'yes' ? children : <Navigate to="/" replace />;
};

export default ProtectedRoute;
